import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { IRequestFilter, IUserOrganization } from "../../../../../../../models";
import { useAppSelector } from "../../../../../../../redux/hooks";
import { compileNameOfProperty } from "../../../../../../../utils";
import { BooleaMultiSelector } from "../../../../../../common/selectors/multiSelectors/booleanMultiSelector/booleanMultiSelector";
import { MultipleCustomStateSelector } from "../../../../../common/selectors/customStates/multipleCustomState";
import { MultipleMerchandiseOriginSelector } from "../../../../../common/selectors/merchandiseOrigin/multipleMerchandiseOrigin";
import { MultipleMerchandiseTypeSelector } from "../../../../../common/selectors/merchandiseType/multipleMerchandiseType";

import { RequestFilterPopUpStyle } from "../filterStyle.jss";
import { TextInput } from "../../../../../../common/inputs/textInput";

interface IProps {
    onMultipleNumberKeysChange: (name: string, options: number[]) => void;
    onNullableBooleanChange: (name: string, booleanValue: boolean | undefined) => void;
    onInputChange: (event: any, name: string) => void;
    onEnter: () => void;
    schema: any;
    organization: IUserOrganization | undefined;
}
export const RequestMerchandiseFilter: React.FC<IProps> = ({ onMultipleNumberKeysChange, onNullableBooleanChange, onInputChange, onEnter, schema, organization }) => {
    const theme = useTheme();
    const styles = RequestFilterPopUpStyle({ theme });
    const { filter } = useAppSelector((state) => state.requestListFilter);
    const { t } = useTranslation("common", { keyPrefix: "REQUEST_FILTER.FILTER" });

    return (
        <div className={styles.section}>
            {schema.merchandiseTypeIdVisible && (
                
                    <MultipleMerchandiseTypeSelector
                        selectedKeys={filter.merchandiseTypeId}
                        propertyName={compileNameOfProperty<IRequestFilter>("merchandiseTypeId")}
                        title={t("MERCHANDISE_TYPE")}
                        onChange={onMultipleNumberKeysChange}
                        autocomplete={false}
                    />
            )}
            {schema.merchandiseOriginIdVisible && (
                
                    <MultipleMerchandiseOriginSelector
                        selectedKeys={filter.merchandiseOriginId}
                        propertyName={compileNameOfProperty<IRequestFilter>("merchandiseOriginId")}
                        title={t("MERCHANDISE_ORIGIN")}
                        onChange={onMultipleNumberKeysChange}
                        autocomplete={false}
                    />
            )}
            {schema.customsStateIdVisible && (
                
                    <MultipleCustomStateSelector
                        selectedKeys={filter.customsStateId}
                        propertyName={compileNameOfProperty<IRequestFilter>("customsStateId")}
                        title={t("CUSTOMS_STATE")}
                        onChange={onMultipleNumberKeysChange}
                        autocomplete={false}
                    />
            )}

            {schema.halalCertifiedVisible && organization?.halalCertified && (
                
                    <BooleaMultiSelector
                        selectedKey={filter.halalCertified}
                        propertyName={compileNameOfProperty<IRequestFilter>("halalCertified")}
                        title={t("HALAL")}
                        onChange={onNullableBooleanChange}
                    />
            )}
            {schema.dryChargeVisible && organization?.dryCharge && (
                
                    <BooleaMultiSelector
                        selectedKey={filter.dryCharge}
                        propertyName={compileNameOfProperty<IRequestFilter>("dryCharge")}
                        title={t("DRY_CARGO")}
                        onChange={onNullableBooleanChange}
                    />
            )}
            {schema.organicProductVisible && organization?.organicProduct && (
                
                    <BooleaMultiSelector
                        selectedKey={filter.organicProduct}
                        propertyName={compileNameOfProperty<IRequestFilter>("organicProduct")}
                        title={t("ORGANIC_PRODUCT")}
                        onChange={onNullableBooleanChange}
                    />
            )}
            {schema.fumigatedVisible && organization?.fumigated && (
                
                    <BooleaMultiSelector
                        selectedKey={filter.fumigated}
                        propertyName={compileNameOfProperty<IRequestFilter>("fumigated")}
                        title={t("FUMIGATED_CONTAINER")}
                        onChange={onNullableBooleanChange}
                    />
            )}
               {schema.descriptionVisible && (
                    <TextInput
                        value={filter.description}
                        propertyName={compileNameOfProperty<IRequestFilter>("description")}
                        label={t("DESCRIPTION")}
                        onChange={onInputChange}
                        onEnter={onEnter}
                    />
            )}
        </div>
    );
};
